import { createSelector } from 'reselect';
import { subselect } from './root';
import { propertiesSelector } from './properties';

const apiParamsSelector = createSelector(
  [propertiesSelector],
  ({ appName = 'na', appVersion = 0 }) => ({
    appName,
    appVersion,
  }),
);

export const applicationApiParamsSelector = subselect(apiParamsSelector);
